import { FC } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { UserRegistration } from '../../../models/UserRegistration';
import UserRegistrationEndpoint from '../../../../api/endpoint/UserRegistrationEndpoint';

interface DeleteEventModalProps {
    user: UserRegistration;
    show: boolean;
    onHide: () => void;
    initiateReload: () => void;
}

export const DeleteRegistrationModal: FC<DeleteEventModalProps> = ({user, show, onHide, initiateReload}) => {
    const onDelete = async() => {
        const removeResult = await UserRegistrationEndpoint.Remove(user.user_registration_id);
        if(!removeResult || removeResult.errors.length > 0) {
            console.error("Error removing course event.");
        } else {
            initiateReload();
        }
        onHide()
    };

    return(
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="delete-event-title"
            centered
        >
            <Modal.Header>
                <Modal.Title id="delete-event-title">Delete Registration for {user.full_name}?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                This action cannot be undone.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-" onClick={onHide}>Cancel</Button>
                <Button variant="danger" onClick={onDelete}>Delete</Button>
            </Modal.Footer>
        </Modal>
    )
};